import Link from "next/link";
import { useRouter } from "next/router";
import { stringify } from "qs";

import { clearKeysFromQuery } from "hooks/useClearQueryStringKeys";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";

const DesktopFilterColumnUI = ({
  chips,
  filters,
}: {
  chips: React.ReactNode;
  filters: React.ReactNode;
}) => {
  const { asPath } = useRouter();
  const { path, query } = parseNextRouterAsPath(asPath);

  return (
    <div className="hidden md:block">
      <div className="hidden text-xs md:flex justify-between items-center">
        <span className="font-extrabold uppercase">Filters</span>

        <Link
          href={{
            pathname: path,
            query: stringify(
              clearKeysFromQuery(query, [
                "filter",
                "fulfillment",
                "page",
                "q",
                "sort",
              ]),
            ),
          }}
          className="underline text-xs font-bold"
        >
          clear all
        </Link>
      </div>

      <div
        className="mb-4 flex flex-wrap items-center gap-1"
        data-testid="filter-chips"
      >
        {chips}
      </div>
      {filters}
    </div>
  );
};

export default DesktopFilterColumnUI;
